import type { ConfigType } from '@plone/registry';
import NewsItemView from '../components/News/NewsItemView/NewsItemView';

/**
 * Views customizadas por content type.
 * Notícia = News Item estendido (docs/specs/plone/content-types.md §1).
 */
export default function installViews(config: ConfigType) {
  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    'News Item': NewsItemView,
  };

  return config;
}
